import React from 'react';
import './StatisticsGrid.css';

interface StatData {
  title: string;
  value: string;
  subtitle: string;
}

interface StatisticsGridProps {
  stats: StatData[];
}

const StatisticsGrid: React.FC<StatisticsGridProps> = ({ stats }) => {
  return (
    <div className="stats-grid">
      {stats.map((stat, index) => (
        <div key={index} className="stat-card">
          <div className="stat-title">{stat.title}</div>
          <div className="stat-value">{stat.value}</div>
          <div className="stat-subtitle">{stat.subtitle}</div>
        </div>
      ))}
    </div>
  );
};

export default StatisticsGrid;
